import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listUsers } from '../Api'

export default generateApiAction({
  baseType: Types.USERS.LIST,
  api: listUsers,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/users/ListAction.js